import { toast } from 'react-toastify'

interface Indicacao {
  mensagem: string
  indicacao: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handlerErrorFgts(error: any, defaultMessage?: string) {
  if (error?.messages && !error?.stack) {
    error?.messages.map((e: Indicacao) => {
      toast.error('FGTS: ' + e?.mensagem, {
        className: 'text-break',
        autoClose: false
      })
    })
  } else {
    defaultMessage
      ? toast.error(defaultMessage, {
          className: 'text-break',
          autoClose: false
        })
      : toast.error('FGTS: Não foi possível!', {
          className: 'text-break',
          autoClose: false
        })
  }
}
